<template lang="pug">
    .settings(v-if='settings')
        div(v-for="({ num, numbers, operations }) in settings.examples")
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}:
                | {{ num }}
            br
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_operations') }}:
                | {{ getOperationName(operations) }}
            br
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_numbers') }}:
                | {{ numbers.join(', ') }}
            br
        slot
</template>

<script>
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
        },
        methods: {
            getOperationName(operations) {
                if (operations.multiply) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_operationMultiply');
                }
                return this.$i18n.t('trainer.trainer_gameFormSetting_operationDivide');
            },
        },
    };
</script>
